module.exports = __webpack_public_path__ + "static/media/correct-key.4a48db6b.mp3";